import React from "react";
import RegionDataList from "./RegionDataList";
import RegionCreateForm from "./RegionCreateForm";
import RegionEditForm from "./RegionEditForm";

///////////////////// LIST ALL REGIONS /////////////////////
export const RegionList = props => <RegionDataList {...props} />;

export const RegionCreate = props => <RegionCreateForm {...props} />;

export const RegionEdit = props => <RegionEditForm {...props} />;


// WEBPACK FOOTER //
// ./src/containers/CRM/Regions/index.js